// Images
import logoUrl from "~images/logo_top.svg"

interface LogoProps {
  className?: string
}

const Logo = ({ className = "" }: LogoProps) => {
  return <img src={logoUrl} className={className} alt="Perk Central Logo" />
}

export default Logo
